'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessages = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * 
 * @param {ThreadHistory} threadHistory 
 * @returns {OrderedMap<PubNubMessageKey, PubNubMessageRecord>}
 */
var getMessages = exports.getMessages = (0, _getIn2.default)(_keyPaths.MESSAGES);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/getMessages.js
// module id = 27
// module chunks = 2 3